export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ10.3c158a92.mp3";